<script>
  import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
  const db = getFirestore();

  export let appPageTitle;
  export let closeFbForm;

  let feedbackText = "";
  let isSubmitted = false;

  async function submitFeedback() {
    const feedbackCollection = collection(db, "feedbacks");
    await addDoc(feedbackCollection, {
      content: feedbackText,
      timestamp: serverTimestamp(),
    });
    isSubmitted = true;
  }

   let placeholderText = "We appreciate your feedback...include your email if you want to be in touch!";

  function handleFocus() {
    placeholderText = "";
  }

  function handleBlur() {
    if (!feedbackText.trim()) {
      placeholderText = "We appreciate your feedback...include your email if you want to be in touch!";
    }
  }
</script>

<div class="fixed inset-0 w-screen h-screen flex items-center justify-center z-50">
  <!-- Background overlay -->
  <div class="absolute inset-0 bg-black opacity-70" on:click={closeFbForm}></div>

  <!-- Modal content -->
  <div class="relative w-[600px] h-[95vh] max-h-[95vh] flex flex-col justify-between rounded-3xl bg-slate-50 p-8 text-slate-900 ring-1 ring-slate-300 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-300/20 xl:p-10 z-10 overflow-y-auto">

  <div class="absolute left-[calc(50%-4rem)] -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)] top-10" aria-hidden="true"><div class="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-20" style="clip-path: polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%);"></div></div>
    
    <div>

      <div class="flex items-center gap-x-4">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" 
         class="h-9 w-9 text-blue-600"
         fill="currentColor"
         stroke="currentColor"
         stroke-width="5"
         viewBox="0 0 184 236">
        <metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
        <g>
            <g>
                <g>
                    <path d="M170.2,11.6c-2.2,2.2-2,6.3,0.2,8.4c1.7,1.6,2.6,1.7,15.1,1.7h13.2l-16.9,16.9L165,55.5l-4.9-3.2c-7.8-5.1-15.9-7.3-26.2-7.3c-9.7-0.1-15.8,1.2-23.4,5.1c-12.7,6.4-21.2,16.3-25.9,29.9c-2,5.5-2.2,7.3-2.2,16s0.2,10.5,2.2,16c3.9,11.4,10.3,19.8,19.7,26.2c3.3,2.1,6.8,4.1,7.8,4.4c2.3,0.6,5.5-1.3,6.7-4.1c1.3-2.9-0.2-5.3-5.9-8.9C95.5,118.6,89.2,97,97.9,79.1c5-10.2,13.4-17.5,24.1-20.8c4.5-1.3,6.8-1.6,13.4-1.3c7.2,0.3,8.6,0.6,14,3.2c30.2,14.4,30.9,55.4,1.2,70.9c-6.2,3.2-7,4.1-7,7.8c0,2.6,3.1,5.5,5.9,5.5c3.1,0,12.8-5.5,18-10.4c7.9-7.3,13.3-16.2,15.5-25.7c1.3-5.9,1.5-17.6,0.3-23.4c-0.9-4.1-5.4-14.5-8.3-18.8l-1.4-2.1l16.4-16.4c9-9.1,16.6-16.4,17-16.4c0.4,0,0.6,5.9,0.6,13.1c0,12.7,0.1,13.2,1.8,14.8c2.6,2.4,6.3,2.3,8.3-0.3c1.6-2,1.6-3,1.6-23.4s-0.1-21.3-1.6-23.4l-1.6-2h-22.3C172.8,10,171.7,10.1,170.2,11.6z"/>
                    <path d="M63.6,81.6c-8.2,4.4-17.2,13.6-21.4,22.1c-7.4,15.2-7.4,31,0,46.1c2.6,5.2,4.7,8,9.6,12.9c8.3,8.2,15.5,12,28,14.8l2.1,0.5v14v14l-12,0.3c-10.5,0.2-12.3,0.4-13.7,1.7c-2.5,2.3-2.3,6.9,0.4,9c1.9,1.5,3.1,1.6,13.7,1.6h11.6v11.6c0,10.5,0.2,11.8,1.6,13.7c2,2.6,6.2,2.8,8.5,0.5c1.4-1.4,1.6-2.6,1.6-13.7v-12.1H105c12.5,0,14.6-0.5,16.1-4.1c0.8-1.9,0.8-2.7-0.2-4.4c-2-3.4-4.1-4-16.1-4H93.6V192V178l2.2-0.4c5.9-1.2,15.5-4.8,19.8-7.7c9.7-6.4,16.8-15.5,20.8-26.5c2.7-7.5,3.3-20.2,1.3-28.4c-3.2-14-13.4-27.3-25.8-33.5c-3.4-1.8-4.4-2-6.2-1.3c-2.8,1.1-4.2,3-4.3,5.6c0,2.6,1.9,4.6,6.4,7c7.7,3.9,15.6,14.7,18.2,24.5c4.5,17.3-4.3,36.2-20.5,44.3c-15.9,8-33.7,4.8-45.7-7.8c-5.9-6.2-8.7-11.6-10.4-19.3c-1.4-6.8-1.4-8.8,0-15.6c2.5-11.8,10.2-22,20.4-27c7.6-3.8,9.3-7.4,5.4-11.3C72.7,78,70,78.3,63.6,81.6z"/>
                </g>
            </g>
        </g>
    </svg>
       
        <h3 id="tier-starter" class="text-lg font-semibold leading-8">{appPageTitle}</h3>



        <div class="ml-auto">
            <p 
                class="rounded-full text-base font-semibold leading-5 text-gray-400 hover:text-white cursor-default"
                on:click={closeFbForm}
            >
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </p>
        </div>
    </div>

<!--
        <div class="p-4 mt-4 rounded-lg shadow-md space-y-4">
  <h2 class="text-xl font-bold">Tips for a Smooth {appPageTitle} Journey 🚀</h2>
  
  <ul class="list-decimal pl-5 space-y-4">
    <li class="text-sm">
      <span class="font-semibold">Engage & Introduce:</span> Dive into the narrative! Play along and feel free to introduce your AI companions to friends and fellow adventurers.
    </li>
    <li class="text-sm">
      <span class="font-semibold">Steer the Conversation:</span> If your chat seems astray, don't hesitate to tap the refresh button. It'll guide the conversation back on course.
    </li>
    <li class="text-sm">
      <span class="font-semibold">Patience Pays in Pixels:</span> Our high-definition 1024p imagery takes a moment to craft. Trust us, the wait is worth every stunning pixel!
    </li>
    <li class="text-sm">
      <span class="font-semibold">Directing the Story:</span> When you wish to add an action or narration instead of dialog, simply write "Action: " at the start of your message. This enables you to influence and direct the unfolding adventure in exciting, new directions!
    </li>
     

  </ul>

  <p class="text-gray-300 text-sm">Enjoy your voyage through the endless AI cosmos.</p>
</div>

-->

<div class="p-4 mt-4 rounded-lg shadow-md space-y-4">
   {#if isSubmitted}
  <p class="text-white-500">Thank you for your feedback!</p>
  <button on:click={closeFbForm} class="bg-blue-500 text-white px-4 py-2">
  Close
</button>
{:else}
    <textarea 
      bind:value={feedbackText} 
      placeholder={placeholderText} 
      class="w-full h-40 p-2 border text-black" 
      on:focus={handleFocus} 
      on:blur={handleBlur}

      ></textarea>
    <button on:click={submitFeedback} class="bg-blue-500 text-white px-4 py-2" disabled={!feedbackText}>
  Submit Feedback
</button>
{/if}
</div>




     </div>


  </div>
</div>


     



